import React, { useState } from 'react'
import Project from './Project';

const projectData=[
    {
        id:1,
        title:"E-commerce website",
        description:"A user, after creating an account using (email, google, github). He/ She can buy any product as he likes. A user can view all the details of a product, searching product, sorting and can add to cart / wishlist / buy. Different dashboard admin, seller, user. Seller can add products. Admin approves then the product will show.",
        link:"https://e-commerce-website-99d1a.web.app/",
        server_code:"https://github.com/wdridoy11/e-commerce-website-server",
        client_code:"https://github.com/wdridoy11/e-commerce-website-client",
        img:"https://github.com/wdridoy11/web-icon/blob/main/project-04.png?raw=true",
        tools:["React JS","React-router","React-hook-form","Tailwind CSS","daisyui","Firebase","React-toastify","Express JS","MongoDB","Axios", "Stripe"]
    },
    {
        id:2,
        title:"Educational toy website",
        description:"Hello, I have created Educational toy website. Educational toy website full dynamic. Users can create an account on the website using Google or email, and can login. After creating user account, he/she will get some features He can create toy, update toy, and delete toy. Clicking on the View Details button will show the toy details, but if the user is not logged in then it will not be visible. He can see his own toy, search toy, and sorting by price. You will see his profile picture and name.",
        link:"https://toy-marketplace-dfdd7.web.app/",
        server_code:"https://github.com/wdridoy11/toy-marketplace-server-side",
        client_code:"https://github.com/wdridoy11/toy-marketplace-client-side",
        img:"https://raw.githubusercontent.com/wdridoy11/web-icon/main/education-1.png",
        tools:["React JS","React-router","Tailwind CSS","daisyui","Firebase","lightgallery","React tabs","Express JS","MongoDB "]
    },
    {
        id:3,
        title:"Food Recipe website",
        description:" Hello, I have created food recipe website.  It's dynamic website. User can register and can login. User create account email, google, GitHub. If the user is not logged in, he/she will not be able to see the recipe items, they are protected with a private routes. By clicking on View Recipe, he/she will see the recipe details and from there he can add favorites. He/she can download the blog in PDF form from the blog page.",
        link:"https://food-recipe-707c1.web.app/",
        server_code:"https://github.com/wdridoy11/chinese-food-server-side",
        client_code:"https://github.com/wdridoy11/chinese-food-client-side",
        img:"https://raw.githubusercontent.com/wdridoy11/web-icon/main/food-recipe.png",
        tools:["React JS","React-router","Tailwind CSS","daisyui","Firebase","React-to-pdf","React-toastify","Express JS","MongoDB"]
    },
    
    // {
    //     id:3,
    //     title:"Sports academies website",
    //     description:"User can login and register, by default user join this website as a student. By default, everyone will be a student, And he will see student dashboard. If someone joins here as a student, then he/she can select his preferred class and buy that class. If the admin makes someone an instructor, then he/she can add classes here. If the admin wants, he/she can make someone an instructor and can also make admits And can also delete",
    //     link:"https://sports-academies.web.app/",
    //     server_code:"https://github.com/wdridoy11/sports_academie_server",
    //     client_code:"https://github.com/wdridoy11/sports_academie_client",
    //     img:"https://raw.githubusercontent.com/wdridoy11/web-icon/main/sports.png",
    //     tools:["React JS","React-router","React-hook-form","React-to-pdf","Tailwind CSS","daisyui","Firebase","lightgallery","React-toastify","Express JS","MongoDB"]
    // },
];

const Projects = () => {

const [modalData,setModalData]=useState([])
const handleModal =(id)=>{
    const selected = projectData.find((modalId)=>modalId.id === id);
    setModalData(selected)
}

  return (
    <div className='bg-[#0E1629] py-20'>
        <div className='container mx-auto'>
            <div className="text-center pb-12">
                <h1 className="text-5xl font-medium text-[#22d3ee]">Recent project</h1>
                <p className="text-base mt-1 text-white">My Recent Complete project</p>
            </div>
            <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-5'>
                {projectData.map((project)=><Project key={project.id} project={project} handleModal={handleModal} modalData={modalData}></Project>)}
            </div>
        </div>
    </div>
  )
}

export default Projects